import * as React from "react";
import jyloMark from "../../../assets/logo-jylo-dark.png";

/**
 * The small Jylo mark that identifies an assistant turn: the white logo mark on a tile of
 * the exact logo blue.
 *
 * Deliberately `bg-brand`, not `bg-primary`. In light mode the accent is a step darker
 * than the logo so that small white TEXT on it clears 4.5:1; this tile carries a graphic,
 * which needs 3:1 (WCAG 1.4.11), and the white mark on the logo blue is 3.26:1. On the
 * accent it read as a different, darker blue from the logo in the header. The logo blue
 * is the same in both schemes, like the logo files themselves.
 *
 * The size is a prop (20 in a turn's identity row, 36 in the empty state), so the
 * dimensions are inline styles rather than classes: they are computed, not chosen from
 * a scale.
 */
const AssistantMark = ({ size = 20 }: { size?: number }) => (
  <span
    className="inline-flex flex-none items-center justify-center bg-brand"
    style={{ width: size, height: size, borderRadius: size * 0.3 }}
  >
    <img
      src={jyloMark}
      alt=""
      className="block object-contain"
      style={{ width: size * 0.6, height: size * 0.6 }}
    />
  </span>
);

export default AssistantMark;
